export default __webpack_public_path__ + "static/landing-de8875c60ca49aa83494d83e3ac74a6b.png";